import { createContext, useContext } from 'react';

import { type PortalProps } from '@frontend/components';

export type OverlayContainerRefContextValue = {
  containerRef?: PortalProps['containerRef'];
};

export const OverlayContainerRefContext = createContext<
  OverlayContainerRefContextValue & {
    parents?: OverlayContainerRefContextValue['containerRef'][];
  }
>({});

type OverlayContainerRefContextProviderProps =
  React.ProviderProps<OverlayContainerRefContextValue>;

export const OverlayContainerRefContextProvider = ({
  value,
  ...restProps
}: OverlayContainerRefContextProviderProps) => {
  const parentContext = useContext(OverlayContainerRefContext);
  const valueWithParents = {
    ...value,
    parents: [...(parentContext.parents ?? []), value.containerRef],
  };
  return (
    <OverlayContainerRefContext.Provider
      value={valueWithParents}
      {...restProps}
    />
  );
};
